import React, {useEffect, useRef, useState} from 'react';
import Chart from "chart.js";

export default function ResultsChart(props) {

    let [chart, setChart] = useState('');

    const refChart = useRef(null);

    // let chart = null;

    useEffect(() => {
        const taken = props.data.taken;
        const completed = props.data.completed;
        const labels = props.data.labels;
        const data = {
            labels: labels,
            datasets: [{
                label: 'Total tests taken',
                borderWidth: 1,
                borderColor: '#93EB97',
                pointBackgroundColor: '#93EB97',
                backgroundColor: 'rgba(200, 200, 200, 0.1)',
                fill: true,
                data: taken
            },{
                label: 'All tests complete',
                borderWidth: 1,
                borderColor: '#23AA29',
                pointBackgroundColor: '#23AA29',
                backgroundColor: 'rgba(200, 200, 200, 0.1)',
                fill: true,
                data: completed
            }]
        };

        const maxValue = Math.max(Math.max(...completed), Math.max(...taken));
        let step = 200;
        if (maxValue <= 10) {
            step = 2;
        } else if (maxValue <= 50) {
            step = 10;
        } else if (maxValue <= 100) {
            step = 10;
        } else if (maxValue <= 500) {
            step = 100;
        }

        const yAxes = [{
            ticks: {
                min: 0,
                padding: 5,
                stepSize: step,
                fontFamily:'Sofia-Pro-Regular',
                fontSize: 8
            },
            gridLines: {
                fontFamily:'Sofia-Pro-Regular',
                color: 'rgba(200, 200, 200, 0.08)',
                lineWidth: 1,
                display:true,
                zeroLineColor: 'rgba(200, 200, 200, 0.2)',
                zeroLineWidth: 2,
                tickMarkLength:0,
            },
            scaleLabel: {
                fontFamily:'Sofia-Pro-Regular',
                titleFontFamily: 'Sofia-Pro-Regular',
                display: false,
                fontColor: '#FFFFFF',
                labelString: 'Users',
                drawOnChartArea: true,
                padding:10,
            }
        }];

        if (chart) {
            chart.data = data;
            chart.options.scales.yAxes = yAxes;
            chart.update();
        } else {
            const options = {
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    easing: 'easeInOutQuad',
                    duration: 520
                },
                scales: {
                    xAxes: [{
                        type: 'category',
                        position: 'bottom',
                        ticks: {
                            stepSize: 1,
                            fontFamily:'Sofia-Pro-Regular',
                            fontSize: 8
                        },
                        gridLines: {
                            fontFamily:'Sofia-Pro-Regular',
                            color: 'rgba(200, 200, 200, 0.08)',
                            lineWidth: 0,
                            display:true,
                            zeroLineColor: 'rgba(200, 200, 200, 0.2)',
                            zeroLineWidth: 2
                        },
                        scaleLabel: {
                            fontFamily:'Sofia-Pro-Regular',
                            titleFontFamily: 'Sofia-Pro-Regular',
                            display: false,
                            fontColor: '#FFFFFF'
                        }
                    }],
                    yAxes: yAxes
                },
                tooltips: {
                    enabled: true,
                    titleFontSize: 0,
                    titleMarginBottom: 0
                },
                elements: {
                    line: {
                        tension: 0,
                    },
                    point: {
                        radius:3
                    },
                },
                legend: {
                    display: false
                }
            };
            let newChart = new Chart(refChart.current.getContext("2d"), {
                type: 'line',
                defaultFontFamily: 'Sofia-Pro-Regular',
                data: data,
                options: options
            });

            setChart(newChart);
        }
    }, [props.data]);

    return (
            <canvas id="myChart" ref={refChart}/>
    )

}